export default __webpack_public_path__ + "img/sagoo/seq/sagoo5_1500.webp";